//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './StudyClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetAdminStudiesStudyQueryParameters = {
  searchQuery?: string | null | null;
  withFailedToken?: boolean | null | null;
  isClosed?: boolean | null | null;
  hasEcrf?: boolean | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type GetDoctorStudiesStudyQueryParameters = {
  searchQuery?: string | null | null;
  withFailedToken?: boolean | null | null;
  isClosed?: boolean | null | null;
  hasEcrf?: boolean | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type GetDoctorStudyByIdStudyQueryParameters = {
  id: number;
};

export type GetStudyAttachmentsStudyQueryParameters = {
  studyId: number;
};

export type AddAttachmentToStudyStudyMutationParameters = {
  attachments?: Types.FileParameter[] | null | undefined ; 
};

export type GetRecruitmentProgressStudyQueryParameters = {
  studyId: number;
};

export type GetPatientsSummaryStudyQueryParameters = {
  studyId: number;
};

export type GetStudyUserListStudyQueryParameters = {
  studyId: number;
  searchQuery?: string | null | null;
  roles?: string[] | null | null;
  favoriteUserIds?: string[] | null | null;
  tags?: { [key: string]: string[]; } | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: Types.StaffSorting | null | null;
  sortOrder?: Types.SortOrder | null | null;
};

export type GetStudyStaffTagsStudyQueryParameters = {
  studyId: number;
};

export type GetStudyAllTagsStudyQueryParameters = {
  studyId: number;
};

export type GetStudyStaffPerRoleStudyQueryParameters = {
  studyId: number;
};

    
export function getAdminStudiesUrl(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/studies/listForAdmin?";
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (withFailedToken !== undefined && withFailedToken !== null)
    url_ += "WithFailedToken=" + encodeURIComponent("" + withFailedToken) + "&";
if (isClosed !== undefined && isClosed !== null)
    url_ += "IsClosed=" + encodeURIComponent("" + isClosed) + "&";
if (hasEcrf !== undefined && hasEcrf !== null)
    url_ += "HasEcrf=" + encodeURIComponent("" + hasEcrf) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAdminStudiesDefaultOptions: UseQueryOptions<Types.PagedResultOfAdminStudyDto, unknown, Types.PagedResultOfAdminStudyDto> = {
  queryFn: __getAdminStudies,
};
export function getGetAdminStudiesDefaultOptions(): UseQueryOptions<Types.PagedResultOfAdminStudyDto, unknown, Types.PagedResultOfAdminStudyDto> {
  return getAdminStudiesDefaultOptions;
};
export function setGetAdminStudiesDefaultOptions(options: UseQueryOptions<Types.PagedResultOfAdminStudyDto, unknown, Types.PagedResultOfAdminStudyDto>) {
  getAdminStudiesDefaultOptions = options;
}

export function getAdminStudiesQueryKey(dto: GetAdminStudiesStudyQueryParameters): QueryKey;
export function getAdminStudiesQueryKey(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getAdminStudiesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder,  } = params[0] as GetAdminStudiesStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getAdminStudies',
        searchQuery as any,
        withFailedToken as any,
        isClosed as any,
        hasEcrf as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getAdminStudies',
        ...params
      ]);
  }
}
function __getAdminStudies(context: QueryFunctionContext) {
  return Client.getAdminStudies(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as boolean | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as Types.SortOrder | undefined    );
}

export function useGetAdminStudiesQuery<TSelectData = Types.PagedResultOfAdminStudyDto, TError = unknown>(dto: GetAdminStudiesStudyQueryParameters, options?: UseQueryOptions<Types.PagedResultOfAdminStudyDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns list of all studies for Admin according to the search query.
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetAdminStudiesQuery<TSelectData = Types.PagedResultOfAdminStudyDto, TError = unknown>(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfAdminStudyDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAdminStudiesQuery<TSelectData = Types.PagedResultOfAdminStudyDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfAdminStudyDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let searchQuery: any = undefined;
  let withFailedToken: any = undefined;
  let isClosed: any = undefined;
  let hasEcrf: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder,  } = params[0] as GetAdminStudiesStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfAdminStudyDto, TError, TSelectData>({
    queryFn: __getAdminStudies,
    queryKey: getAdminStudiesQueryKey(searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder),
    ...getAdminStudiesDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfAdminStudyDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns list of all studies for Admin according to the search query.
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetAdminStudiesData(queryClient: QueryClient, updater: (data: Types.PagedResultOfAdminStudyDto | undefined) => Types.PagedResultOfAdminStudyDto, searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getAdminStudiesQueryKey(searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Returns list of all studies for Admin according to the search query.
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetAdminStudiesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfAdminStudyDto | undefined) => Types.PagedResultOfAdminStudyDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getDoctorStudiesUrl(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/studies/listForDoctor?";
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (withFailedToken !== undefined && withFailedToken !== null)
    url_ += "WithFailedToken=" + encodeURIComponent("" + withFailedToken) + "&";
if (isClosed !== undefined && isClosed !== null)
    url_ += "IsClosed=" + encodeURIComponent("" + isClosed) + "&";
if (hasEcrf !== undefined && hasEcrf !== null)
    url_ += "HasEcrf=" + encodeURIComponent("" + hasEcrf) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDoctorStudiesDefaultOptions: UseQueryOptions<Types.DoctorStudyListDto, unknown, Types.DoctorStudyListDto> = {
  queryFn: __getDoctorStudies,
};
export function getGetDoctorStudiesDefaultOptions(): UseQueryOptions<Types.DoctorStudyListDto, unknown, Types.DoctorStudyListDto> {
  return getDoctorStudiesDefaultOptions;
};
export function setGetDoctorStudiesDefaultOptions(options: UseQueryOptions<Types.DoctorStudyListDto, unknown, Types.DoctorStudyListDto>) {
  getDoctorStudiesDefaultOptions = options;
}

export function getDoctorStudiesQueryKey(dto: GetDoctorStudiesStudyQueryParameters): QueryKey;
export function getDoctorStudiesQueryKey(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getDoctorStudiesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder,  } = params[0] as GetDoctorStudiesStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getDoctorStudies',
        searchQuery as any,
        withFailedToken as any,
        isClosed as any,
        hasEcrf as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getDoctorStudies',
        ...params
      ]);
  }
}
function __getDoctorStudies(context: QueryFunctionContext) {
  return Client.getDoctorStudies(
      context.queryKey[2] as string | null | undefined,       context.queryKey[3] as boolean | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as Types.SortOrder | undefined    );
}

export function useGetDoctorStudiesQuery<TSelectData = Types.DoctorStudyListDto, TError = unknown>(dto: GetDoctorStudiesStudyQueryParameters, options?: UseQueryOptions<Types.DoctorStudyListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Returns doctor's studies
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetDoctorStudiesQuery<TSelectData = Types.DoctorStudyListDto, TError = unknown>(searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.DoctorStudyListDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDoctorStudiesQuery<TSelectData = Types.DoctorStudyListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DoctorStudyListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let searchQuery: any = undefined;
  let withFailedToken: any = undefined;
  let isClosed: any = undefined;
  let hasEcrf: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder,  } = params[0] as GetDoctorStudiesStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.DoctorStudyListDto, TError, TSelectData>({
    queryFn: __getDoctorStudies,
    queryKey: getDoctorStudiesQueryKey(searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder),
    ...getDoctorStudiesDefaultOptions as unknown as UseQueryOptions<Types.DoctorStudyListDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Returns doctor's studies
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDoctorStudiesData(queryClient: QueryClient, updater: (data: Types.DoctorStudyListDto | undefined) => Types.DoctorStudyListDto, searchQuery?: string | null | undefined, withFailedToken?: boolean | null | undefined, isClosed?: boolean | null | undefined, hasEcrf?: boolean | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getDoctorStudiesQueryKey(searchQuery, withFailedToken, isClosed, hasEcrf, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Returns doctor's studies
 * @param searchQuery (optional) Search query string.
e.g. SN147 - return all Studies which has name or study number contains "SN147".
 * @param withFailedToken (optional) Filter for defining studies with expired or revoked token.
 * @param isClosed (optional) Filter for closed study
 * @param hasEcrf (optional) Filter for studies with eCRF enabled.
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDoctorStudiesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DoctorStudyListDto | undefined) => Types.DoctorStudyListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getDoctorStudyByIdUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/{id}/forDoctor";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDoctorStudyByIdDefaultOptions: UseQueryOptions<Types.DoctorStudyDto, unknown, Types.DoctorStudyDto> = {
  queryFn: __getDoctorStudyById,
};
export function getGetDoctorStudyByIdDefaultOptions(): UseQueryOptions<Types.DoctorStudyDto, unknown, Types.DoctorStudyDto> {
  return getDoctorStudyByIdDefaultOptions;
};
export function setGetDoctorStudyByIdDefaultOptions(options: UseQueryOptions<Types.DoctorStudyDto, unknown, Types.DoctorStudyDto>) {
  getDoctorStudyByIdDefaultOptions = options;
}

export function getDoctorStudyByIdQueryKey(id: number): QueryKey;
export function getDoctorStudyByIdQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetDoctorStudyByIdStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getDoctorStudyById',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getDoctorStudyById',
        ...params
      ]);
  }
}
function __getDoctorStudyById(context: QueryFunctionContext) {
  return Client.getDoctorStudyById(
      context.queryKey[2] as number    );
}

export function useGetDoctorStudyByIdQuery<TSelectData = Types.DoctorStudyDto, TError = unknown>(dto: GetDoctorStudyByIdStudyQueryParameters, options?: UseQueryOptions<Types.DoctorStudyDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Return study info for a logged in doctor.
 * @param id Study Id
 */
export function useGetDoctorStudyByIdQuery<TSelectData = Types.DoctorStudyDto, TError = unknown>(id: number, options?: UseQueryOptions<Types.DoctorStudyDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDoctorStudyByIdQuery<TSelectData = Types.DoctorStudyDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DoctorStudyDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetDoctorStudyByIdStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.DoctorStudyDto, TError, TSelectData>({
    queryFn: __getDoctorStudyById,
    queryKey: getDoctorStudyByIdQueryKey(id),
    ...getDoctorStudyByIdDefaultOptions as unknown as UseQueryOptions<Types.DoctorStudyDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return study info for a logged in doctor.
 * @param id Study Id
 */
export function setGetDoctorStudyByIdData(queryClient: QueryClient, updater: (data: Types.DoctorStudyDto | undefined) => Types.DoctorStudyDto, id: number) {
  queryClient.setQueryData(getDoctorStudyByIdQueryKey(id),
    updater
  );
}

/**
 * Return study info for a logged in doctor.
 * @param id Study Id
 */
export function setGetDoctorStudyByIdDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DoctorStudyDto | undefined) => Types.DoctorStudyDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStudyAttachmentsUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/attachments";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyAttachmentsDefaultOptions: UseQueryOptions<Types.StudyAttachmentDto[], unknown, Types.StudyAttachmentDto[]> = {
  queryFn: __getStudyAttachments,
};
export function getGetStudyAttachmentsDefaultOptions(): UseQueryOptions<Types.StudyAttachmentDto[], unknown, Types.StudyAttachmentDto[]> {
  return getStudyAttachmentsDefaultOptions;
};
export function setGetStudyAttachmentsDefaultOptions(options: UseQueryOptions<Types.StudyAttachmentDto[], unknown, Types.StudyAttachmentDto[]>) {
  getStudyAttachmentsDefaultOptions = options;
}

export function getStudyAttachmentsQueryKey(studyId: number): QueryKey;
export function getStudyAttachmentsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetStudyAttachmentsStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getStudyAttachments',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getStudyAttachments',
        ...params
      ]);
  }
}
function __getStudyAttachments(context: QueryFunctionContext) {
  return Client.getStudyAttachments(
      context.queryKey[2] as number    );
}

export function useGetStudyAttachmentsQuery<TSelectData = Types.StudyAttachmentDto[], TError = unknown>(dto: GetStudyAttachmentsStudyQueryParameters, options?: UseQueryOptions<Types.StudyAttachmentDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get all files attached to the study
 * @param studyId Id of the study
 */
export function useGetStudyAttachmentsQuery<TSelectData = Types.StudyAttachmentDto[], TError = unknown>(studyId: number, options?: UseQueryOptions<Types.StudyAttachmentDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyAttachmentsQuery<TSelectData = Types.StudyAttachmentDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyAttachmentDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetStudyAttachmentsStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyAttachmentDto[], TError, TSelectData>({
    queryFn: __getStudyAttachments,
    queryKey: getStudyAttachmentsQueryKey(studyId),
    ...getStudyAttachmentsDefaultOptions as unknown as UseQueryOptions<Types.StudyAttachmentDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get all files attached to the study
 * @param studyId Id of the study
 */
export function setGetStudyAttachmentsData(queryClient: QueryClient, updater: (data: Types.StudyAttachmentDto[] | undefined) => Types.StudyAttachmentDto[], studyId: number) {
  queryClient.setQueryData(getStudyAttachmentsQueryKey(studyId),
    updater
  );
}

/**
 * Get all files attached to the study
 * @param studyId Id of the study
 */
export function setGetStudyAttachmentsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyAttachmentDto[] | undefined) => Types.StudyAttachmentDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function addAttachmentToStudyUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/attachments";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function addAttachmentToStudyMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'addAttachmentToStudy',
      studyId as any,
    ]);
}

/**
 * Add attachment to the study
 * @param studyId Id of the study
 * @param attachments (optional) 
 */
export function useAddAttachmentToStudyMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<Types.StudyAttachmentDto[], unknown, AddAttachmentToStudyStudyMutationParameters, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.StudyAttachmentDto[], unknown, AddAttachmentToStudyStudyMutationParameters, TContext> {
  const key = addAttachmentToStudyMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((addAttachmentToStudyStudyMutationParameters: AddAttachmentToStudyStudyMutationParameters) => Client.addAttachmentToStudy(studyId, addAttachmentToStudyStudyMutationParameters.attachments), {...options, mutationKey: key});
}
  
    
export function removeAttachmentFromStudyUrl(studyId: number, attachmentId: string): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/attachments/{attachmentId}";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (attachmentId === undefined || attachmentId === null)
  throw new Error("The parameter 'attachmentId' must be defined.");
url_ = url_.replace("{attachmentId}", encodeURIComponent("" + attachmentId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeAttachmentFromStudyMutationKey(studyId: number, attachmentId: string): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'removeAttachmentFromStudy',
      studyId as any,
      attachmentId as any,
    ]);
}

/**
 * Remove attachment from the study
 * @param studyId Id of the study
 * @param attachmentId Id of the attachment
 */
export function useRemoveAttachmentFromStudyMutation<TContext>(studyId: number, attachmentId: string, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeAttachmentFromStudyMutationKey(studyId, attachmentId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeAttachmentFromStudy(studyId, attachmentId), {...options, mutationKey: key});
}
  
    
export function syncStudyDataUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/sync/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function syncStudyDataMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'syncStudyData',
      id as any,
    ]);
}

/**
 * Sync PrismaCloud data for given study in background.
 */
export function useSyncStudyDataMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DoctorStudyDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DoctorStudyDto, unknown, void, TContext> {
  const key = syncStudyDataMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.syncStudyData(id), {...options, mutationKey: key});
}
  
    
export function syncStudyDataByAdminUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/sync/{id}/byAdmin";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function syncStudyDataByAdminMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'syncStudyDataByAdmin',
      id as any,
    ]);
}

/**
 * Sync PrismaCloud data for given study in background by Admin.
 */
export function useSyncStudyDataByAdminMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = syncStudyDataByAdminMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.syncStudyDataByAdmin(id), {...options, mutationKey: key});
}
  
    
export function isStudySyncInProgressUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/sync/{id}/ping";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function isStudySyncInProgressMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'isStudySyncInProgress',
      id as any,
    ]);
}

/**
 * Sync PrismaCloud data for given study in background by Admin.
 */
export function useIsStudySyncInProgressMutation<TContext>(id: number, options?: Omit<UseMutationOptions<boolean, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<boolean, unknown, void, TContext> {
  const key = isStudySyncInProgressMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.isStudySyncInProgress(id), {...options, mutationKey: key});
}
  
    
export function getMyStudyUrl(): string {
  let url_ = getBaseUrl() + "/api/studies";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMyStudyDefaultOptions: UseQueryOptions<Types.PatientStudyDto, unknown, Types.PatientStudyDto> = {
  queryFn: __getMyStudy,
};
export function getGetMyStudyDefaultOptions(): UseQueryOptions<Types.PatientStudyDto, unknown, Types.PatientStudyDto> {
  return getMyStudyDefaultOptions;
};
export function setGetMyStudyDefaultOptions(options: UseQueryOptions<Types.PatientStudyDto, unknown, Types.PatientStudyDto>) {
  getMyStudyDefaultOptions = options;
}

export function getMyStudyQueryKey(): QueryKey;
export function getMyStudyQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'StudyClient',
      'getMyStudy',
    ]);
}
function __getMyStudy() {
  return Client.getMyStudy(
    );
}

/**
 * Return study for the logged in patient.
 */
export function useGetMyStudyQuery<TSelectData = Types.PatientStudyDto, TError = unknown>(options?: UseQueryOptions<Types.PatientStudyDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMyStudyQuery<TSelectData = Types.PatientStudyDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientStudyDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientStudyDto, TError, TSelectData>({
    queryFn: __getMyStudy,
    queryKey: getMyStudyQueryKey(),
    ...getMyStudyDefaultOptions as unknown as UseQueryOptions<Types.PatientStudyDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return study for the logged in patient.
 */
export function setGetMyStudyData(queryClient: QueryClient, updater: (data: Types.PatientStudyDto | undefined) => Types.PatientStudyDto, ) {
  queryClient.setQueryData(getMyStudyQueryKey(),
    updater
  );
}

/**
 * Return study for the logged in patient.
 */
export function setGetMyStudyDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientStudyDto | undefined) => Types.PatientStudyDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createStudyUrl(): string {
  let url_ = getBaseUrl() + "/api/studies";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createStudyMutationKey(): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'createStudy',
    ]);
}

/**
 * Creates a study and assigns it to the current user (Doctor).
 * @param newStudy Request parameter
 */
export function useCreateStudyMutation<TContext>(options?: Omit<UseMutationOptions<Types.AdminStudyDto, unknown, Types.CreateStudyDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AdminStudyDto, unknown, Types.CreateStudyDto, TContext> {
  const key = createStudyMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((newStudy: Types.CreateStudyDto) => Client.createStudy(newStudy), {...options, mutationKey: key});
}
  
    
export function getMyStudy2Url(): string {
  let url_ = getBaseUrl() + "/api/study";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getMyStudy2DefaultOptions: UseQueryOptions<Types.PatientStudyDto, unknown, Types.PatientStudyDto> = {
  queryFn: __getMyStudy2,
};
export function getGetMyStudy2DefaultOptions(): UseQueryOptions<Types.PatientStudyDto, unknown, Types.PatientStudyDto> {
  return getMyStudy2DefaultOptions;
};
export function setGetMyStudy2DefaultOptions(options: UseQueryOptions<Types.PatientStudyDto, unknown, Types.PatientStudyDto>) {
  getMyStudy2DefaultOptions = options;
}

export function getMyStudy2QueryKey(): QueryKey;
export function getMyStudy2QueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'StudyClient',
      'getMyStudy2',
    ]);
}
function __getMyStudy2() {
  return Client.getMyStudy2(
    );
}

/**
 * Return study for the logged in patient.
 */
export function useGetMyStudy2Query<TSelectData = Types.PatientStudyDto, TError = unknown>(options?: UseQueryOptions<Types.PatientStudyDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetMyStudy2Query<TSelectData = Types.PatientStudyDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientStudyDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientStudyDto, TError, TSelectData>({
    queryFn: __getMyStudy2,
    queryKey: getMyStudy2QueryKey(),
    ...getMyStudy2DefaultOptions as unknown as UseQueryOptions<Types.PatientStudyDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Return study for the logged in patient.
 */
export function setGetMyStudy2Data(queryClient: QueryClient, updater: (data: Types.PatientStudyDto | undefined) => Types.PatientStudyDto, ) {
  queryClient.setQueryData(getMyStudy2QueryKey(),
    updater
  );
}

/**
 * Return study for the logged in patient.
 */
export function setGetMyStudy2DataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientStudyDto | undefined) => Types.PatientStudyDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function createGroupUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/groups";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createGroupMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'createGroup',
      studyId as any,
    ]);
}

/**
 * Creates new patient group in the study.
 * @param dto DTO with arguments.
 */
export function useCreateGroupMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<Types.GroupDto, unknown, Types.CreateGroupDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GroupDto, unknown, Types.CreateGroupDto, TContext> {
  const key = createGroupMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.CreateGroupDto) => Client.createGroup(studyId, dto), {...options, mutationKey: key});
}
  
    
export function updateGroupConfigurationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/groups/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateGroupConfigurationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'updateGroupConfiguration',
      id as any,
    ]);
}

/**
 * Updates visibility of columns on dashboard for the specific group.
 * @param id Id of the group.
 * @param dto DTO with new columns values.
 */
export function useUpdateGroupConfigurationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.GroupDto, unknown, Types.UpdateGroupDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.GroupDto, unknown, Types.UpdateGroupDto, TContext> {
  const key = updateGroupConfigurationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.UpdateGroupDto) => Client.updateGroupConfiguration(id, dto), {...options, mutationKey: key});
}
  
    
export function removeGroupUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/groups/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeGroupMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'removeGroup',
      id as any,
    ]);
}

/**
 * Remove the group
 * @param id Id of the group.
 */
export function useRemoveGroupMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeGroupMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.removeGroup(id), {...options, mutationKey: key});
}
  
    
export function updateSettingsUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateSettingsMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'updateSettings',
      id as any,
    ]);
}

/**
 * Updates some study settings.
 * @param id Study to update.
 * @param dto DTO with new values.
 */
export function useUpdateSettingsMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.AdminStudyDto, unknown, Types.PatchStudyDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AdminStudyDto, unknown, Types.PatchStudyDto, TContext> {
  const key = updateSettingsMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.PatchStudyDto) => Client.updateSettings(id, dto), {...options, mutationKey: key});
}
  
    
export function updateStudyInfoPageConfigurationUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/infoPageConfiguration";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updateStudyInfoPageConfigurationMutationKey(studyId: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'updateStudyInfoPageConfiguration',
      studyId as any,
    ]);
}

export function useUpdateStudyInfoPageConfigurationMutation<TContext>(studyId: number, options?: Omit<UseMutationOptions<Types.AdminStudyDto, unknown, Types.StudyInfoPageConfigurationDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AdminStudyDto, unknown, Types.StudyInfoPageConfigurationDto, TContext> {
  const key = updateStudyInfoPageConfigurationMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.StudyInfoPageConfigurationDto) => Client.updateStudyInfoPageConfiguration(studyId, dto), {...options, mutationKey: key});
}
  
    
export function updatePrismaClientSettingsUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/{id}/client";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function updatePrismaClientSettingsMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'updatePrismaClientSettings',
      id as any,
    ]);
}

/**
 * Updates only prisma cloud client settings.
 * @param id Study to update.
 * @param dto DTO with new values.
 */
export function useUpdatePrismaClientSettingsMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.AdminStudyDto, unknown, Types.UpdatePrismaClientDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.AdminStudyDto, unknown, Types.UpdatePrismaClientDto, TContext> {
  const key = updatePrismaClientSettingsMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.UpdatePrismaClientDto) => Client.updatePrismaClientSettings(id, dto), {...options, mutationKey: key});
}
  
    
export function approveClosureStudyUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/{id}/approveClosure";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function approveClosureStudyMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'approveClosureStudy',
      id as any,
    ]);
}

/**
 * Approve closing the study
 * @param id Study to approve closing
 */
export function useApproveClosureStudyMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DoctorStudyDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DoctorStudyDto, unknown, void, TContext> {
  const key = approveClosureStudyMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.approveClosureStudy(id), {...options, mutationKey: key});
}
  
    
export function revokeClosureApprovalStudyUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/{id}/revokeClosureApproval";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function revokeClosureApprovalStudyMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'revokeClosureApprovalStudy',
      id as any,
    ]);
}

/**
 * Revoke of closure approval the study
 * @param id Study to revoke of closure approval
 */
export function useRevokeClosureApprovalStudyMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DoctorStudyDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DoctorStudyDto, unknown, void, TContext> {
  const key = revokeClosureApprovalStudyMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.revokeClosureApprovalStudy(id), {...options, mutationKey: key});
}
  
    
export function closeStudyUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/studies/{id}/closeStudy";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function closeStudyMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'StudyClient',
      'closeStudy',
      id as any,
    ]);
}

/**
 * Close the study
 * @param id Study to approve closing
 */
export function useCloseStudyMutation<TContext>(id: number, options?: Omit<UseMutationOptions<Types.DoctorStudyDto, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DoctorStudyDto, unknown, void, TContext> {
  const key = closeStudyMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.closeStudy(id), {...options, mutationKey: key});
}
  
    
export function getRecruitmentProgressUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/recruitmentProgress";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getRecruitmentProgressDefaultOptions: UseQueryOptions<Types.StudyRecruitmentProgressDto, unknown, Types.StudyRecruitmentProgressDto> = {
  queryFn: __getRecruitmentProgress,
};
export function getGetRecruitmentProgressDefaultOptions(): UseQueryOptions<Types.StudyRecruitmentProgressDto, unknown, Types.StudyRecruitmentProgressDto> {
  return getRecruitmentProgressDefaultOptions;
};
export function setGetRecruitmentProgressDefaultOptions(options: UseQueryOptions<Types.StudyRecruitmentProgressDto, unknown, Types.StudyRecruitmentProgressDto>) {
  getRecruitmentProgressDefaultOptions = options;
}

export function getRecruitmentProgressQueryKey(studyId: number): QueryKey;
export function getRecruitmentProgressQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetRecruitmentProgressStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getRecruitmentProgress',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getRecruitmentProgress',
        ...params
      ]);
  }
}
function __getRecruitmentProgress(context: QueryFunctionContext) {
  return Client.getRecruitmentProgress(
      context.queryKey[2] as number    );
}

export function useGetRecruitmentProgressQuery<TSelectData = Types.StudyRecruitmentProgressDto, TError = unknown>(dto: GetRecruitmentProgressStudyQueryParameters, options?: UseQueryOptions<Types.StudyRecruitmentProgressDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get recruitment progress of the study
 * @param studyId Study to get recruitment progress
 */
export function useGetRecruitmentProgressQuery<TSelectData = Types.StudyRecruitmentProgressDto, TError = unknown>(studyId: number, options?: UseQueryOptions<Types.StudyRecruitmentProgressDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetRecruitmentProgressQuery<TSelectData = Types.StudyRecruitmentProgressDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyRecruitmentProgressDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetRecruitmentProgressStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyRecruitmentProgressDto, TError, TSelectData>({
    queryFn: __getRecruitmentProgress,
    queryKey: getRecruitmentProgressQueryKey(studyId),
    ...getRecruitmentProgressDefaultOptions as unknown as UseQueryOptions<Types.StudyRecruitmentProgressDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get recruitment progress of the study
 * @param studyId Study to get recruitment progress
 */
export function setGetRecruitmentProgressData(queryClient: QueryClient, updater: (data: Types.StudyRecruitmentProgressDto | undefined) => Types.StudyRecruitmentProgressDto, studyId: number) {
  queryClient.setQueryData(getRecruitmentProgressQueryKey(studyId),
    updater
  );
}

/**
 * Get recruitment progress of the study
 * @param studyId Study to get recruitment progress
 */
export function setGetRecruitmentProgressDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyRecruitmentProgressDto | undefined) => Types.StudyRecruitmentProgressDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getPatientsSummaryUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/patientsSummary";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPatientsSummaryDefaultOptions: UseQueryOptions<Types.PatientGroupSummaryDto[], unknown, Types.PatientGroupSummaryDto[]> = {
  queryFn: __getPatientsSummary,
};
export function getGetPatientsSummaryDefaultOptions(): UseQueryOptions<Types.PatientGroupSummaryDto[], unknown, Types.PatientGroupSummaryDto[]> {
  return getPatientsSummaryDefaultOptions;
};
export function setGetPatientsSummaryDefaultOptions(options: UseQueryOptions<Types.PatientGroupSummaryDto[], unknown, Types.PatientGroupSummaryDto[]>) {
  getPatientsSummaryDefaultOptions = options;
}

export function getPatientsSummaryQueryKey(studyId: number): QueryKey;
export function getPatientsSummaryQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetPatientsSummaryStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getPatientsSummary',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getPatientsSummary',
        ...params
      ]);
  }
}
function __getPatientsSummary(context: QueryFunctionContext) {
  return Client.getPatientsSummary(
      context.queryKey[2] as number    );
}

export function useGetPatientsSummaryQuery<TSelectData = Types.PatientGroupSummaryDto[], TError = unknown>(dto: GetPatientsSummaryStudyQueryParameters, options?: UseQueryOptions<Types.PatientGroupSummaryDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get summary of patients in the study for dashboard.
Summary includes count of patients in each group and count of patients in each study state
(e.g. active, dropped out etc.).
 */
export function useGetPatientsSummaryQuery<TSelectData = Types.PatientGroupSummaryDto[], TError = unknown>(studyId: number, options?: UseQueryOptions<Types.PatientGroupSummaryDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPatientsSummaryQuery<TSelectData = Types.PatientGroupSummaryDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PatientGroupSummaryDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetPatientsSummaryStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PatientGroupSummaryDto[], TError, TSelectData>({
    queryFn: __getPatientsSummary,
    queryKey: getPatientsSummaryQueryKey(studyId),
    ...getPatientsSummaryDefaultOptions as unknown as UseQueryOptions<Types.PatientGroupSummaryDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get summary of patients in the study for dashboard.
Summary includes count of patients in each group and count of patients in each study state
(e.g. active, dropped out etc.).
 */
export function setGetPatientsSummaryData(queryClient: QueryClient, updater: (data: Types.PatientGroupSummaryDto[] | undefined) => Types.PatientGroupSummaryDto[], studyId: number) {
  queryClient.setQueryData(getPatientsSummaryQueryKey(studyId),
    updater
  );
}

/**
 * Get summary of patients in the study for dashboard.
Summary includes count of patients in each group and count of patients in each study state
(e.g. active, dropped out etc.).
 */
export function setGetPatientsSummaryDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PatientGroupSummaryDto[] | undefined) => Types.PatientGroupSummaryDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStudyUserListUrl(studyId: number, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, favoriteUserIds?: string[] | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: Types.StaffSorting | null | undefined, sortOrder?: Types.SortOrder | null | undefined): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/users?";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (roles !== undefined && roles !== null)
    roles && roles.forEach(item => { url_ += "Roles=" + encodeURIComponent("" + item) + "&"; });
if (favoriteUserIds !== undefined && favoriteUserIds !== null)
    favoriteUserIds && favoriteUserIds.forEach(item => { url_ += "FavoriteUserIds=" + encodeURIComponent("" + item) + "&"; });
if (tags !== undefined && tags !== null)
{
    const content_ = JSON.stringify(tags);
    url_ += "Tags=" + encodeURIComponent(content_) + "&";
}
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder !== undefined && sortOrder !== null)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyUserListDefaultOptions: UseQueryOptions<Types.PagedResultOfStudyStaffDto, unknown, Types.PagedResultOfStudyStaffDto> = {
  queryFn: __getStudyUserList,
};
export function getGetStudyUserListDefaultOptions(): UseQueryOptions<Types.PagedResultOfStudyStaffDto, unknown, Types.PagedResultOfStudyStaffDto> {
  return getStudyUserListDefaultOptions;
};
export function setGetStudyUserListDefaultOptions(options: UseQueryOptions<Types.PagedResultOfStudyStaffDto, unknown, Types.PagedResultOfStudyStaffDto>) {
  getStudyUserListDefaultOptions = options;
}

export function getStudyUserListQueryKey(dto: GetStudyUserListStudyQueryParameters): QueryKey;
export function getStudyUserListQueryKey(studyId: number, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, favoriteUserIds?: string[] | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: Types.StaffSorting | null | undefined, sortOrder?: Types.SortOrder | null | undefined): QueryKey;
export function getStudyUserListQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId, searchQuery, roles, favoriteUserIds, tags, offset, limit, sortBy, sortOrder,  } = params[0] as GetStudyUserListStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getStudyUserList',
        studyId as any,
        searchQuery as any,
        roles as any,
        favoriteUserIds as any,
        tags as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getStudyUserList',
        ...params
      ]);
  }
}
function __getStudyUserList(context: QueryFunctionContext) {
  return Client.getStudyUserList(
      context.queryKey[2] as number,       context.queryKey[3] as string | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as { [key: string]: string[]; } | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as number | null | undefined,       context.queryKey[9] as Types.StaffSorting | null | undefined,       context.queryKey[10] as Types.SortOrder | null | undefined    );
}

export function useGetStudyUserListQuery<TSelectData = Types.PagedResultOfStudyStaffDto, TError = unknown>(dto: GetStudyUserListStudyQueryParameters, options?: UseQueryOptions<Types.PagedResultOfStudyStaffDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get list of study users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) User role
 * @param favoriteUserIds (optional) List of favorite users
 * @param tags (optional) User's tags
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Sorting criteria.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetStudyUserListQuery<TSelectData = Types.PagedResultOfStudyStaffDto, TError = unknown>(studyId: number, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, favoriteUserIds?: string[] | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: Types.StaffSorting | null | undefined, sortOrder?: Types.SortOrder | null | undefined, options?: UseQueryOptions<Types.PagedResultOfStudyStaffDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyUserListQuery<TSelectData = Types.PagedResultOfStudyStaffDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfStudyStaffDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  let searchQuery: any = undefined;
  let roles: any = undefined;
  let favoriteUserIds: any = undefined;
  let tags: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId, searchQuery, roles, favoriteUserIds, tags, offset, limit, sortBy, sortOrder,  } = params[0] as GetStudyUserListStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, searchQuery, roles, favoriteUserIds, tags, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfStudyStaffDto, TError, TSelectData>({
    queryFn: __getStudyUserList,
    queryKey: getStudyUserListQueryKey(studyId, searchQuery, roles, favoriteUserIds, tags, offset, limit, sortBy, sortOrder),
    ...getStudyUserListDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfStudyStaffDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get list of study users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) User role
 * @param favoriteUserIds (optional) List of favorite users
 * @param tags (optional) User's tags
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Sorting criteria.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetStudyUserListData(queryClient: QueryClient, updater: (data: Types.PagedResultOfStudyStaffDto | undefined) => Types.PagedResultOfStudyStaffDto, studyId: number, searchQuery?: string | null | undefined, roles?: string[] | null | undefined, favoriteUserIds?: string[] | null | undefined, tags?: { [key: string]: string[]; } | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: Types.StaffSorting | null | undefined, sortOrder?: Types.SortOrder | null | undefined) {
  queryClient.setQueryData(getStudyUserListQueryKey(studyId, searchQuery, roles, favoriteUserIds, tags, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Get list of study users
 * @param searchQuery (optional) Search query string.
e.g. Mike - return all users which name or last name contains "Mike".
 * @param roles (optional) User role
 * @param favoriteUserIds (optional) List of favorite users
 * @param tags (optional) User's tags
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Sorting criteria.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetStudyUserListDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfStudyStaffDto | undefined) => Types.PagedResultOfStudyStaffDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStudyStaffTagsUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/userTags";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyStaffTagsDefaultOptions: UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }> = {
  queryFn: __getStudyStaffTags,
};
export function getGetStudyStaffTagsDefaultOptions(): UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }> {
  return getStudyStaffTagsDefaultOptions;
};
export function setGetStudyStaffTagsDefaultOptions(options: UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }>) {
  getStudyStaffTagsDefaultOptions = options;
}

export function getStudyStaffTagsQueryKey(studyId: number): QueryKey;
export function getStudyStaffTagsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetStudyStaffTagsStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getStudyStaffTags',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getStudyStaffTags',
        ...params
      ]);
  }
}
function __getStudyStaffTags(context: QueryFunctionContext) {
  return Client.getStudyStaffTags(
      context.queryKey[2] as number    );
}

export function useGetStudyStaffTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(dto: GetStudyStaffTagsStudyQueryParameters, options?: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get tags of the study users and tags of patients that are visible for the user according to his tags.
 * @param studyId Study ID
 */
export function useGetStudyStaffTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(studyId: number, options?: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyStaffTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetStudyStaffTagsStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<{ [key: string]: string[]; }, TError, TSelectData>({
    queryFn: __getStudyStaffTags,
    queryKey: getStudyStaffTagsQueryKey(studyId),
    ...getStudyStaffTagsDefaultOptions as unknown as UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>,
    ...options,
  });
}
/**
 * Get tags of the study users and tags of patients that are visible for the user according to his tags.
 * @param studyId Study ID
 */
export function setGetStudyStaffTagsData(queryClient: QueryClient, updater: (data: { [key: string]: string[]; } | undefined) => { [key: string]: string[]; }, studyId: number) {
  queryClient.setQueryData(getStudyStaffTagsQueryKey(studyId),
    updater
  );
}

/**
 * Get tags of the study users and tags of patients that are visible for the user according to his tags.
 * @param studyId Study ID
 */
export function setGetStudyStaffTagsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: { [key: string]: string[]; } | undefined) => { [key: string]: string[]; }) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStudyAllTagsUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/allTags";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyAllTagsDefaultOptions: UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }> = {
  queryFn: __getStudyAllTags,
};
export function getGetStudyAllTagsDefaultOptions(): UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }> {
  return getStudyAllTagsDefaultOptions;
};
export function setGetStudyAllTagsDefaultOptions(options: UseQueryOptions<{ [key: string]: string[]; }, unknown, { [key: string]: string[]; }>) {
  getStudyAllTagsDefaultOptions = options;
}

export function getStudyAllTagsQueryKey(studyId: number): QueryKey;
export function getStudyAllTagsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetStudyAllTagsStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getStudyAllTags',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getStudyAllTags',
        ...params
      ]);
  }
}
function __getStudyAllTags(context: QueryFunctionContext) {
  return Client.getStudyAllTags(
      context.queryKey[2] as number    );
}

export function useGetStudyAllTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(dto: GetStudyAllTagsStudyQueryParameters, options?: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * This method used to get all tags of the study users and patients for admin.
 */
export function useGetStudyAllTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(studyId: number, options?: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyAllTagsQuery<TSelectData = { [key: string]: string[]; }, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetStudyAllTagsStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<{ [key: string]: string[]; }, TError, TSelectData>({
    queryFn: __getStudyAllTags,
    queryKey: getStudyAllTagsQueryKey(studyId),
    ...getStudyAllTagsDefaultOptions as unknown as UseQueryOptions<{ [key: string]: string[]; }, TError, TSelectData>,
    ...options,
  });
}
/**
 * This method used to get all tags of the study users and patients for admin.
 */
export function setGetStudyAllTagsData(queryClient: QueryClient, updater: (data: { [key: string]: string[]; } | undefined) => { [key: string]: string[]; }, studyId: number) {
  queryClient.setQueryData(getStudyAllTagsQueryKey(studyId),
    updater
  );
}

/**
 * This method used to get all tags of the study users and patients for admin.
 */
export function setGetStudyAllTagsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: { [key: string]: string[]; } | undefined) => { [key: string]: string[]; }) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getStudyStaffPerRoleUrl(studyId: number): string {
  let url_ = getBaseUrl() + "/api/studies/{studyId}/usersPerRole";
if (studyId === undefined || studyId === null)
  throw new Error("The parameter 'studyId' must be defined.");
url_ = url_.replace("{studyId}", encodeURIComponent("" + studyId));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getStudyStaffPerRoleDefaultOptions: UseQueryOptions<Types.StudyStaffPerRoleDto[], unknown, Types.StudyStaffPerRoleDto[]> = {
  queryFn: __getStudyStaffPerRole,
};
export function getGetStudyStaffPerRoleDefaultOptions(): UseQueryOptions<Types.StudyStaffPerRoleDto[], unknown, Types.StudyStaffPerRoleDto[]> {
  return getStudyStaffPerRoleDefaultOptions;
};
export function setGetStudyStaffPerRoleDefaultOptions(options: UseQueryOptions<Types.StudyStaffPerRoleDto[], unknown, Types.StudyStaffPerRoleDto[]>) {
  getStudyStaffPerRoleDefaultOptions = options;
}

export function getStudyStaffPerRoleQueryKey(studyId: number): QueryKey;
export function getStudyStaffPerRoleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetStudyStaffPerRoleStudyQueryParameters;

    return trimArrayEnd([
        'StudyClient',
        'getStudyStaffPerRole',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'StudyClient',
        'getStudyStaffPerRole',
        ...params
      ]);
  }
}
function __getStudyStaffPerRole(context: QueryFunctionContext) {
  return Client.getStudyStaffPerRole(
      context.queryKey[2] as number    );
}

export function useGetStudyStaffPerRoleQuery<TSelectData = Types.StudyStaffPerRoleDto[], TError = unknown>(dto: GetStudyStaffPerRoleStudyQueryParameters, options?: UseQueryOptions<Types.StudyStaffPerRoleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get study users per role
 */
export function useGetStudyStaffPerRoleQuery<TSelectData = Types.StudyStaffPerRoleDto[], TError = unknown>(studyId: number, options?: UseQueryOptions<Types.StudyStaffPerRoleDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetStudyStaffPerRoleQuery<TSelectData = Types.StudyStaffPerRoleDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.StudyStaffPerRoleDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetStudyStaffPerRoleStudyQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.StudyStaffPerRoleDto[], TError, TSelectData>({
    queryFn: __getStudyStaffPerRole,
    queryKey: getStudyStaffPerRoleQueryKey(studyId),
    ...getStudyStaffPerRoleDefaultOptions as unknown as UseQueryOptions<Types.StudyStaffPerRoleDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get study users per role
 */
export function setGetStudyStaffPerRoleData(queryClient: QueryClient, updater: (data: Types.StudyStaffPerRoleDto[] | undefined) => Types.StudyStaffPerRoleDto[], studyId: number) {
  queryClient.setQueryData(getStudyStaffPerRoleQueryKey(studyId),
    updater
  );
}

/**
 * Get study users per role
 */
export function setGetStudyStaffPerRoleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.StudyStaffPerRoleDto[] | undefined) => Types.StudyStaffPerRoleDto[]) {
  queryClient.setQueryData(queryKey, updater);
}